import React from 'react'

const LauncherIcon2 = () => {
    return (
        <svg
            focusable="false"
            stroke="currentColor"
            fill="none"
            strokeWidth="2"
            viewBox="0 0 16 16"
            strokeLinecap="round"
            strokeLinejoin="round"
            height="1.3em"
            width="1.3em"
            style={{ width: '30px', height: '30px' }}
        >
            <path d="M2 0a2 2 0 00-2 2v12.793a.5.5 0 00.854.353l2.853-2.853A1 1 0 014.414 12H14a2 2 0 002-2V2a2 2 0 00-2-2H2z"
                strokeWidth="0" fill="currentColor" />
        </svg>
    )
}

export default LauncherIcon2